import {ExamModule, Question} from '@cp/model';
import {QuestionFormData} from '../../../types/QuestionFormData';

/**
 * Convert Question to QuestionFormData for form use
 */
export default function mapQuestionToQuestionData(
  question: Question,
  examModules: ExamModule[],
  providedModuleId?: string,
): QuestionFormData {
  // Find the module that contains this question's topic
  let questionModuleId = providedModuleId;
  if (!questionModuleId) {
    const questionModule = examModules.find((module) =>
      module.topics.some((topic) => topic.topic === question.moduleTopic.topic),
    );
    questionModuleId = questionModule?.id;
  }

  // Validate that the moduleId exists in examModules
  // If examModules is empty or the moduleId doesn't exist, set to empty string
  // This prevents MUI Select errors when the value doesn't match available options
  const moduleExists =
    examModules.length > 0 && questionModuleId && examModules.some((module) => module.id === questionModuleId);
  const validModuleId = moduleExists ? questionModuleId : '';

  // Get available topics for the selected module
  const selectedModule = examModules.find((module) => module.id === validModuleId);
  const moduleTopics = selectedModule?.topics || [];
  const questionTopic = question.moduleTopic.topic || '';

  // If the question's topic doesn't exist in the module's topics, set to blank
  const topicExists = moduleTopics.some((topic) => topic.topic === questionTopic);
  const topicValue = topicExists ? questionTopic : '';

  return {
    answer: question.answer,
    difficulty: question.difficulty,
    explanation: question.explanation,
    hint: question.hint || '',
    options: question.options,
    questionText: question.questionText,
    status: question.status,
    statusNote: question.statusNote || '',
    feedbackPositive: question.feedbackPositive ?? 0,
    feedbackNegative: question.feedbackNegative ?? 0,
    moduleId: validModuleId || '',
    topic: topicValue,
    image: undefined, // Don't set image from existing question, use imageUrl for display
    graphJson: question.graphJsonString || '',
  };
}
